<template>
  <svg class="xds:icon" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.08125 1.66H4M5.62825 1.66H7M4.14722 6.3C4.14722 6.66451 4.44271 6.96 4.80722 6.96C5.17172 6.96 5.46722 6.66451 5.46722 6.3C5.46722 5.93549 5.17172 5.64 4.80722 5.64C4.44271 5.64 4.14722 5.93549 4.14722 6.3ZM4.14722 6.3L1.08125 6.3M5.5 6.3H7M7 3.98H3.80005M2.34528 3.98H1M5.46722 1.66C5.46722 2.02451 5.17172 2.32 4.80722 2.32C4.44271 2.32 4.14722 2.02451 4.14722 1.66C4.14722 1.29549 4.44271 1 4.80722 1C5.17172 1 5.46722 1.29549 5.46722 1.66ZM2.42638 3.98001C2.42638 4.34452 2.72188 4.64001 3.08638 4.64001C3.45089 4.64001 3.74638 4.34452 3.74638 3.98001C3.74638 3.6155 3.45089 3.32001 3.08638 3.32001C2.72188 3.32001 2.42638 3.6155 2.42638 3.98001Z"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linecap="round"
    />
  </svg>
</template>
